// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Pipeline handle styling constants.
 *
 * Handles are generic connection points - nodes determine their own
 * input/output flexibility at runtime.
 */

/**
 * Visual color for handles.
 */
export const HANDLE_COLOR = '#475569' // slate-600

/**
 * Standard pipeline node dimensions.
 */
export const NODE_WIDTH = 280

/**
 * Handle visual styling - single source of truth.
 */
export const HANDLE_STYLE = {
  size: 14,
  border: '3px solid white',
  borderRadius: '50%',
  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  offset: 7,
  bottomOffset: 10,
} as const

/**
 * Node icon styling - bold outline icons without background.
 */
export const NODE_ICON_STYLE = {
  size: 'w-6 h-6',
  strokeWidth: 2,
} as const

/**
 * Node content spacing - consistent padding and gaps.
 */
export const NODE_SPACING = {
  content: 'px-3 py-3',
  footer: 'px-3 py-1.5',
  gap: 'gap-3',
  subtitleIndent: 'pl-11',
} as const
